import { Layout as AntLayout } from "antd";
import { BiX } from "react-icons/bi";
import styled from "styled-components";

export const MainLayout = styled(AntLayout)`
  height: 100%;
  background-color: var(--white);
  position: relative;
`;

export const Layout = styled(AntLayout)`
  height: 100%;
  margin-left: 64px;
  position: relative;
  background-color: var(--white);
  &:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    transition: background-color 0.2s;
  }
  &.expandedSidebar {
    &:after {
      width: 100%;
      height: 100%;
      background-color: rgb(0, 0, 0, 0.2);
    }
  }
  & > .content {
    height: 100%;
    &.overflow {
      overflow-y: auto;
    }
  }
  @media only screen and (max-device-width: 812px) {
    margin-left: 0;
  }
`;

export const BannerContainer = styled.div`
  width: 100%;
  height: 42px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  padding: 8px 32px 8px 24px;
  background-color: var(--ant-primary-color-hover);

  @media only screen and (max-device-width: 812px) {
    font-size: 12px;
    line-height: 16px;
  }
`;

export const BannerAnchor = styled.a`
  color: black;
  min-width: 80px;
  font-weight: 600;
  margin-left: 16px;
  text-align: center;
  text-decoration: underline;

  &:hover {
    color: var(--ant-primary-9);
    text-decoration: underline;
  }

  @media only screen and (max-device-width: 812px) {
    margin-left: 12px;
  }
`;

export const CloseIcon = styled(BiX)`
  position: absolute;
  right: 8px;
  width: 20px;
  height: 20px;
  color: black;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    color: var(--ant-primary-9);
    transition: 0.3s;
  }
`;
